import { createFeatureSelector, createSelector, Selector } from '@ngrx/store';

import { Group } from '@rocksoft/security-sdk';
import { selectCurrentGroupChildren } from '../member-group/member-group.selector';
import { selectCurrentGroupId } from '../router/security-router.selector';
import * as fromGroup from './group.reducer';
import { GroupState } from './group.state';

export const selectGroupState = createFeatureSelector<GroupState>('groups');

export const selectGroupIds = createSelector(selectGroupState, fromGroup.selectGroupIds);

export const selectAllGroups = createSelector(selectGroupState, fromGroup.selectAllGroups);

export const selectCurrentGroup: Selector<object, Group | undefined> = createSelector(
  selectCurrentGroupId,
  selectAllGroups,
  (groupId, groups) => {
    const group = groups.find((x) => x.id === groupId);
    return group ? group : undefined;
  }
);

export const selectGroupNameFromId = (id: string) =>
  createSelector(selectAllGroups, (allGroups: Group[]) => {
    if (allGroups && id) {
      const group = allGroups.find((x) => x.id === id);
      return group ? group.displayName : undefined;
    }
    return undefined;
  });

export const selectAllPossibleChildren = createSelector(
  selectAllGroups,
  selectCurrentGroupChildren,
  selectCurrentGroupId,
  (allGroups: Group[], currentChildren: Group[], currentGroupId: string) =>
    allGroups && currentChildren && currentGroupId
      ? allGroups.filter(
          (group) =>
            group.id !== currentGroupId &&
            currentChildren.every((child) => group.id !== child.id && child.parentId === currentGroupId)
        )
      : undefined
);

export const selectGroupsLoaded = createSelector(selectAllGroups, (groups: Group[]) => groups && groups.length > 0);
